/** leboncoin (FR) — textes page succès après captcha. */
export const leboncoinFrSuccessCopy = {
  secureHeader: "Réception d'argent en toute sécurité",
  stepLabel: 'Étape 1/2',
  titleSold: 'Votre produit a été acheté',
  buyerLine: 'Acheteur',
  addressLine: 'Livraison',
  statusBanner:
    "L'acheteur a déjà payé pour votre produit, l'argent est en sécurité, allez le chercher.",
  ctaGetMoney: "Obtenir de l'argent",
  shipHint:
    "Une fois que les fonds ont été crédités sur votre compte, les détails de l'expédition des marchandises s'affichent. L'article doit être expédié dans les 3 jours suivant la réception du paiement.",
  trustTitle: 'Nous nous soucions de votre sécurité',
  trustBuyTitle: 'Acheter en toute sécurité',
  trustBuyBody:
    "Tous les paiements sur leboncoin sont cryptés. Notre prestataire de paiement certifié dispose de la technologie nécessaire pour vérifier que l'argent envoyé et reçu est correct. Les protocoles de sécurité pour les transactions et la protection de vos données personnelles sont notre priorité. Vos informations financières ne sont pas communiquées à des tiers ; les données sont transmises par des canaux cryptés et traitées conformément à nos engagements.",
  trustSupportTitle: 'Notre soutien',
  trustSupportBody:
    "Vous pouvez nous contacter 24 h/24 et recevoir une réponse sous 24 h. Notre équipe examine chaque demande et cherche une solution adaptée. Chaque situation lors d'un retrait ou d'une réception d'argent est traitée en priorité. Contactez un spécialiste via le chat pour une réponse rapide et claire.",
  footerTagline: 'leboncoin, la plateforme de la seconde main au quotidien.',
  footerCol1Title: 'leboncoin',
  footerCol1Links: 'À propos, Carrières, Développement durable, Presse, Publicité',
  footerCol2Title: 'Découvrir',
  footerCol2Links: "Comment ça marche ?, Applications mobiles, Centre d'aide, Tableau de bord",
  footerCol3Title: 'Aide',
  footerCol3Links: "Centre d'aide, Vendre, Acheter, Confiance et sécurité",
  footerCol4Title: 'Communauté',
  footerCol4Links: 'Forum',
  footerLegal:
    'Politique de confidentialité · Politique de cookies · Paramètres des cookies · Termes et conditions · Notre plateforme',
  loading: 'Chargement…',
};
